import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import {
  bulkEmployeeUpdate,
  bulkWelcomeMail,
  getEmployeeKeys,
  getEmployeeList,
} from "../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import debounce from "lodash.debounce";
import { postEmployeeFollow } from "../Dashboard/Services/DashboardServices";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getEmployeeSummary,
  UpdateOfficialEmail,
} from "../MyProfile/Service/profileService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dialog } from "primereact/dialog";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { setMessageRequestData } from "../../../Services/Redux/DataTransferToAnother";
import { useDispatch } from "react-redux";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
const defaultImage = "/images/placeholder_profile.png";

function TeamDirectory() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [showmember, setShowmember] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [employeeTeam, setEmployeeTeam] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [employeDetailsOfDropdown, setEmployeDetailsOfDropdown] = useState([]);
  const [employeTeamData, setEmployeTeamData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeTeamId, setEmployeeTeamId] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [displayedTeams, setDisplayedTeams] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState(1);
  const [showNoData, setShowNoData] = useState("");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [employeeUpdate, setEmployeeUpdate] = useState(false);
  const [employeeViewExEmp, setEmployeeViewExEmp] = useState(false);
  const [show, setShow] = useState(false);
  const [employeeCount, setEmployeeCount] = useState(false);
  const [teamSearchValue, setTeamSearchValue] = useState("");
  const [OfficialEmailId, setOfficialEmailId] = useState();
  const dropdownRef = useRef(null);
  const history = useHistory();
  const [noData, setNoData] = useState([]);
  const [IsExEmployeeView, setIsExEmployeeView] = useState(false);
  let SearchValue = "";
  const [visible, setVisible] = useState(false);
  const [visibleMail, setVisibleMail] = useState(false);
  const [emailHeader, setEmailHeader] = useState([]);
  const [emailText, setEmailText] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [visibleEmpUpdate, setVisibleEmpUpdate] = useState(false);
  const [employeeKeyDeta, setEmployeeKeyDeta] = useState([]);
  const [updateField, setUpdateField] = useState([]);
  const dispatch = useDispatch();
  let pageSize;
  const [emailValid, setEmailValid] = useState("");
  const [RegionList, setRegionList] = useState([]);
  const [ZoneList, setZoneList] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [chatRead, setChatRead] = useState(false);

  useEffect(() => {
    getEmployeeKeysData();
    getmasterZoneList();
    getmasterRegionList();
    GetMasterSystemAlertList("No_EmployeeRecord", 2);
    GetMasterSystemAlertList("Header_Email", 3);
    GetMasterSystemAlertList("Text_Email", 4);
    GetMasterSystemAlertList("no_one_is_reporting ", 5);
    permissionAccouncementList();
    getEmployeeCount();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setDisplayedTeams(showAll ? employeTeamData : employeTeamData.slice(0, 8));
  }, [employeTeamData, showAll]);

  useEffect(() => {
    fetchEmployeeData(currentPage, rowsPerPage, SearchValue, IsExEmployeeView);
  }, [
    currentPage,
    rowsPerPage,
    sortField,
    sortOrder,
    IsExEmployeeView,
    selectedZone,
    selectedRegion,
  ]);

  useEffect(() => {
    // Runs whenever employeeTeam changes
  }, [employeeTeam]);

  const redirectToAnotherPage = (employee) => {
    dispatch(setMessageRequestData([employee]));
    history.push(`/Messages`);
  };

  const emailValidation = Yup.object().shape({
    email: Yup.string()
      .transform((value) => value.trim())
      .required("Email is required.")
      .email("Email is invalid."),
  });

  async function editEmail(editEmailDetails) {
    if (editEmailDetails) {
      setOfficialEmailId(editEmailDetails.Id);
      const editEmailDetailsData = {
        EmpId: editEmailDetails.Id,
        email: editEmailDetails?.UserName,
        OrgId: editEmailDetails?.OrgId,
      };
      emailFrom.setValues(editEmailDetailsData);
    }
  }

  const emailFrom = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: emailValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const params = {
        EmpId: data?.EmpId,
        OrgId: userDetails.OrgId,
        OfficialEmail: data?.email?.toLocaleLowerCase(),
      };
      try {
        const res = await UpdateOfficialEmail(params);
        if (res?.StatusCode === 2000) {
          setEmailValid("");
          document.getElementById("btn-close")?.click();
          GetMasterSystemAlertList("Updated_official_email", 0);
        } else {
          setEmailValid(res?.Message);
        }
        if (userDetails?.EmpId === OfficialEmailId) {
          setVisible(true);
        }
        fetchEmployeeData(
          currentPage,
          rowsPerPage,
          SearchValue,
          IsExEmployeeView,
        );
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST?.UpdateOfficialEmail);
        // document.getElementById("btn-close")?.click();
      }
    },
  });

  const getDynamicValidationSchema = (field) => {
    if (!field)
      return Yup.object({
        selectedField: Yup.object()
          .nullable()
          .required("Please select a field to update."),
      });

    return Yup.object({
      selectedField: Yup.object()
        .nullable()
        .required("Please select a field to update."),
      [field.KeyName]: Yup.string().required(`${field.KeyDesc} is required.`),
    });
  };

  const updateEmployeeRecordFrom = useFormik({
    enableReinitialize: true,
    initialValues: {
      selectedField: null, // Must be `null` or full object, not ""
      ...(updateField ? { [updateField.KeyName]: "" } : {}),
    },
    validationSchema: getDynamicValidationSchema(updateField),
    onSubmit: async (data) => {
      const empIds = selectedEmployees.map((emp) => emp.EmpId).join(",");
      let updateRecord;
      if (updateField.InputTypeId === 105) {
        updateRecord = {
          EmployeeIds: empIds,
          keyId: updateField?.KeyId,
          Value: (data?.[updateField?.KeyName]).toString(),
          Text: (updateField?.KeyName).toString(),
        };
      } else {
        updateRecord = {
          EmployeeIds: empIds,
          keyId: updateField?.KeyId,
          Value: (data?.[updateField?.KeyName]).toString(),
          Text: (data?.[updateField?.KeyName]).toString(),
        };
      }
      const params = updateRecord;
      try {
        const response = await bulkEmployeeUpdate(params);
        setVisibleEmpUpdate(false);
        toster.current.success("Employee profile updated");
        fetchEmployeeData(
          currentPage,
          rowsPerPage,
          SearchValue,
          IsExEmployeeView,
        );
        setSelectedEmployees([]);
        if (response) {
          updateEmployeeRecordFrom.resetForm();
          setUpdateField(null);
          document.body.classList.remove("modal-open");
          getEmployeeCount();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST?.DefaultError);
      }
    },
  });

  function updateCancel() {
    updateEmployeeRecordFrom.resetForm();
    setUpdateField(null);
    document.body.classList.remove("modal-open");
  }

  function updatefieldValue(selected) {
    setUpdateField(selected);
  }

  const handleLogout = () => {
    setVisible(false);
    // document.querySelector("#logout-Email .btn-close")?.click();
    GetMasterSystemAlertList("SignOut_message", 0);
    localStorage.clear();
    if (localStorage.length >= 0) {
      history.push("/");
    }
  };

  const handleCloseModal = () => {
    setEmailValid("");
    document.getElementById("btn-close")?.click();
    emailFrom.resetForm();
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type === 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setEmailHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 4) {
        setEmailText(msg?.Desc);
      } else if (msg?.Name == message && type == 5) {
        setShowNoData(msg?.Desc);
      }
    });
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
      if (UserPermission.PermissionName == "Employee.Update") {
        setEmployeeUpdate(true);
      }
      if (UserPermission.PermissionName == "Employee.ViewExEmployee") {
        setEmployeeViewExEmp(true);
      }
      if (UserPermission.PermissionName == "Chat.Read") {
        setChatRead(true);
      }
    });
  };

  const [EmployeesNameData, setemployeesNameData] = useState([]);
  async function fetchEmployeeData(
    pageNumber,
    pageSize,
    SearchValue,
    IsExEmployeeView,
  ) {
    // setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: SearchValue,
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: IsExEmployeeView ? 1 : 0,
      pageNumber: SearchValue ? 1 : pageNumber + 1,
      pageSize: pageSize,
      EmployeeId: 0,
      ZoneId: selectedZone ? selectedZone : 0,
      RegionId: selectedRegion ? selectedRegion : 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      const employeesNameData = employeesList.Data || [];
      const employeeLogdinName = employeesNameData.find(
        (employee) => employee.Id === userDetails?.EmpId,
      );
      pageSize = employeesNameData[0]?.totalEmpCount;
      fetchEmployeeIdData(pageSize);
      if (employeeLogdinName) {
        setemployeesNameData(employeeLogdinName);
        setSelectedEmployee(employeeLogdinName);
        setEmployeeTeamId(employeeLogdinName?.EmpId);
        getTeamMemberListOfEmployee(
          employeeLogdinName?.EmpId,
          teamSearchValue,
          pageSize,
        );
      }

      // Perform Sorting Before Updating State
      let sortedData = [...employeesList.Data];

      if (sortField) {
        sortedData.sort((a, b) => {
          let valueA = a[sortField] ?? ""; // Handle null/undefined values
          let valueB = b[sortField] ?? "";

          if (typeof valueA === "string") valueA = valueA.toLowerCase();
          if (typeof valueB === "string") valueB = valueB.toLowerCase();

          return sortOrder === 1
            ? valueA > valueB
              ? 1
              : valueA < valueB
                ? -1
                : 0
            : valueA < valueB
              ? 1
              : valueA > valueB
                ? -1
                : 0;
        });
      }
      setEmployeeTeam(sortedData);
      // if(employeesList.Data[0]?.totalEmpCount > 0){

      // }
      console.log("employeesList.Data[0]?.totalEmpCount", employeesList.Data[0]?.totalEmpCount);
      setTotalRecords(employeesList.Data[0]?.totalEmpCount ?? 0);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ gap: "5px" }}
      >
        <Link to={`/Profile/${rowData.GUID}`} className="view-teamdetail">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-eye"
            viewBox="0 0 16 16"
          >
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
          </svg>
        </Link>
        {/* <Link
              to="Dashboard"
              className="btn btn-danger shadow btn-xs sharp me-1"
            >
              <i className="fa fa-star"></i>
            </Link> */}

        {userDetails?.EmpId !== rowData?.EmpId && (
          <>
            {rowData.IsFollowed === 1 ? (
              <div
                onClick={() => PostEmployeeFollow(rowData.Id)}
                className="follow-unfollow-member"
                style={{ cursor: "pointer" }}
                title="UnFollow"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  style={{
                    color: "#ffffff",
                    background: " #671cc9",
                  }}
                  fill="currentColor"
                  className="bi bi-hand-thumbs-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                </svg>
              </div>
            ) : (
              <>
                <div
                  onClick={() => PostEmployeeFollow(rowData.Id)}
                  className="follow-unfollow-member"
                  style={{ cursor: "pointer" }}
                  title="Follow"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-hand-thumbs-up-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                  </svg>
                </div>
              </>
            )}
          </>
        )}
        {employeeCreate && userDetails?.EmpId !== rowData?.EmpId && (
          <Link className="view-teamdetail">
            <img
              onClick={() => editEmail(rowData)}
              aria-label="Email"
              src="/images/org-img/editEmail.png"
              title="Edit Email"
              data-bs-toggle="modal"
              data-bs-target="#edit-Email"
            />
          </Link>
        )}
        {userDetails?.EmpId !== rowData?.EmpId && chatRead && (
          <Link className="view-teamdetail">
            <svg
              onClick={() => redirectToAnotherPage(rowData)}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chat-text"
              viewBox="0 0 16 16"
            >
              <title>Chat</title>
              <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
              <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
            </svg>
          </Link>
        )}
      </div>
    );
  };

  const handleInputChange = (e) => {
    handleSearch(e.target.value);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      fetchEmployeeData(
        currentPage,
        rowsPerPage,
        SearchValue,
        IsExEmployeeView,
      );
    }, 800),
    [currentPage, rowsPerPage, IsExEmployeeView],
  );

  async function PostEmployeeFollow(Id) {
    let params = {
      FollowerId: userDetails?.EmpId,
      EmpId: Id,
    };
    try {
      await postEmployeeFollow(params);
      setEmployeeTeam((prevTeam) =>
        prevTeam.map((emp) =>
          emp.EmpId === Id
            ? { ...emp, IsFollowed: emp.IsFollowed === 0 ? 1 : 0 }
            : emp,
        ),
      );
    } catch (error) {
      toster.current.error(ERROR_LIST?.PostEmployeeFollow);
    }
  }

  // For Get All Employee of visible in dropdown.
  async function fetchEmployeeIdData(pageSize) {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: pageSize || 10000,
      EmployeeId: userDetails?.EmpId,
      ZoneId: selectedZone ? selectedZone : 0,
      RegionId: selectedRegion ? selectedRegion : 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      const employeesListData = employeesList.Data || [];
      setEmployeDetailsOfDropdown(employeesListData);
      const employeeLogdin = employeesListData.find(
        (employee) => employee.Id === userDetails?.EmpId,
      );
      if (employeeLogdin) {
        setSelectedEmployee(employeeLogdin);
        setEmployeeTeamId(employeeLogdin?.EmpId);
        getTeamMemberListOfEmployee(
          employeeLogdin?.EmpId,
          teamSearchValue,
          employeesListData[0]?.totalEmpCount,
        );
      }
    } catch (error) {
      // Handle error
    }
  }

  const handleInputChangeEmployee = (e) => {
    setEmployeeTeamId(e.value.EmpId);
    getTeamMemberListOfEmployee(e.value.EmpId, teamSearchValue, pageSize);
  };

  const employeeOptionTemplate = (option) => {
    return (
      <>
        {" "}
        {option.Id != userDetails?.EmpId && (
          <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
            <LazyImage
              alt={option.FullName}
              src={option.ProfileImage}
              width="32"
              height="32"
            />
            <span>{option.FullName}</span>
          </div>
        )}
      </>
    );
  };

  const selectedAssignName = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
          <LazyImage
            alt={option.FullName}
            src={option.ProfileImage}
            width="32"
          />
          <span>{option.FullName}</span>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  async function getTeamMemberListOfEmployee(EmpId, TeamSearchValue, pageSize) {
    setShowLoader(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 3,
      SearchText: TeamSearchValue,
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: pageSize || 10000,
      EmployeeId: EmpId,
      ZoneId: selectedZone ? selectedZone : 0,
      RegionId: selectedRegion ? selectedRegion : 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      const employeesTeamListData = employeesList.Data || [];
      if (employeesTeamListData.length === 0) {
        setShowmember(true);
      } else {
        setShowmember(false);
      }
      setShowLoader(false);
      setEmployeTeamData(employeesTeamListData);
    } catch (error) { }
  }

  const handleInputChangeForTeam = (e) => {
    handleSearchTeam(e.target.value);
  };

  const handleSearchTeam = useCallback(
    debounce((value) => {
      setTeamSearchValue(value);
      getTeamMemberListOfEmployee(employeeTeamId, value, pageSize);
    }, 800),
    [employeeTeamId],
  );

  const goToUserDetail = (detail) => {
    history.push(`/Profile/${detail.GUID}`);
  };

  const styleFullName = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.GUID}`}>
        <div className="d-flex align-items-center">
          <img
            src={rowData?.ProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width="24"
            alt=""
          />{" "}
          <span className="w-space-no">
            {rowData?.FullName} ({rowData?.EmploymentId})
          </span>
        </div>
      </Link>
    );
  };

  const styleOverseerName = (rowData) => {
    let observerId = employeDetailsOfDropdown.filter(
      (item) => item.EmpId === rowData?.OverseerId,
    );
    if (rowData?.OverseerName) {
      return (
        <Link to={`/Profile/${observerId[0]?.GUID}`}>
          <div className="d-flex align-items-center">
            <img
              src={rowData?.OverseerImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="24"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData?.OverseerName}</span>
          </div>
        </Link>
      );
    }
    return <span>Not Assigned</span>;
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const onPageChange = (e) => {
    setCurrentPage(e.page);
    setRowsPerPage(e.rows);
    fetchEmployeeData(e.page, e.rows, SearchValue, IsExEmployeeView);
  };

  // Handle Sorting
  const onSortChange = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  async function getEmployeeCount() {
    const params = {};
    try {
      let employeeDashboardCountData = await getEmployeeSummary(params);
      setEmployeeCount(employeeDashboardCountData.Data);
    } catch (error) { }
  }

  const toggleDropdown = () => setShow((prev) => !prev);

  const handleInputChangeExEmployee = (e) => {
    const newValue = e.value;
    setIsExEmployeeView(newValue);
  };

  const onSelectionChange = (event) => {
    const value = event.value;

    setSelectedEmployees(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event) => {
    const selectAll = event.checked;

    if (selectAll) {
      setSelectAll(true);
      setSelectedEmployees(employeeTeam);
    } else {
      setSelectAll(false);
      setSelectedEmployees([]);
    }
  };

  function editEmployeeProfile(data) {
    document.body.classList.add("modal-open");
    setVisibleEmpUpdate(true);
  }

  async function getEmployeeKeysData() {
    // Get Employee Keys.
    try {
      let employeeKeys = await getEmployeeKeys();
      const toRemove = [
        104, 109, 110, 111, 108, 127, 140, 141, 131, 132, 136, 135, 128, 118,
      ];
      const removeUnUseField = employeeKeys?.Data.filter(
        (item) => !toRemove.includes(item.KeyId),
      );
      setEmployeeKeyDeta(removeUnUseField);
    } catch (error) { }
  }

  const renderFormField = (field, formik) => {
    const isInvalid =
      formik.touched[field.KeyName] && formik.errors[field.KeyName];

    switch (field.InputTypeId) {
      case 101:
        return (
          <input
            type="text"
            name={field.KeyName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[field.KeyName] || ""}
            className={`form-control ${isInvalid ? "is-invalid" : ""}`}
          />
        );
      case 102:
        return (
          <textarea
            rows="4"
            cols="4"
            name={field.KeyName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[field.KeyName] || ""}
            className={`form-control h-auto ${isInvalid ? "is-invalid" : ""}`}
          />
        );
      case 107:
        return (
          <div className="cover-form">
            <input
              type="date"
              name={field.KeyName}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values[field.KeyName] || ""}
              className={`form-control ${isInvalid ? "is-invalid" : ""}`}
            />
          </div>
        );
      case 105:
        return (
          <div className="cover-form">
            <Dropdown
              name={field.KeyName}
              value={formik.values[field.KeyName]}
              onChange={(e) => formik.setFieldValue(field.KeyName, e.value)}
              options={field.EmpKeyOptions}
              optionLabel="Option"
              optionValue="Id"
              placeholder={`Select ${field.KeyDesc}`}
              filter
            />
          </div>
        );
      default:
        return null;
    }
  };

  async function sendMail() {
    const empIds = selectedEmployees.map((emp) => emp.EmpId).join(",");
    if (empIds) {
      const params = {
        EmployeeIds: empIds,
      };
      try {
        const response = await bulkWelcomeMail(params);
        setVisibleMail(false);
        if (response.StatusCode === 2999) {
          toster.current.error(response?.Message);
        } else {
          toster.current.success("Your welcome mails are on their way!");
          fetchEmployeeData(
            currentPage,
            rowsPerPage,
            SearchValue,
            IsExEmployeeView,
          );
        }
      } catch (error) { }
    }
  }

  async function getmasterZoneList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgZone",
    };
    try {
      const data = await GetMasterTypeData(params);
      setZoneList(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getmasterRegionList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgRegion",
    };
    try {
      const data = await GetMasterTypeData(params);
      setmasterRegionList(data?.Data);
      setRegionList(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const [masterRegionList, setmasterRegionList] = useState([]);
  const onChangeZone = (e) => {
    setSelectedZone(e.value);

    if (e.value) {
      var filterRegion = masterRegionList.filter((region) => {
        return Number(region?.Code) === e.value;
      });
    } else {
      var filterRegion = masterRegionList;
    }

    setRegionList(filterRegion);
    setCurrentPage(0);
  };

  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Team Directory</h2>
                <p>Know your colleague & find their contact information.</p>
              </div>
              {employeeCreate && (
                <div className="rightside-tabs">
                  <button
                    className="add-newticket w-auto float-right"
                    onClick={toggleDropdown}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Member
                  </button>
                  <div
                    className="nav-item dropdown notification_dropdown dashboard-addmore-employee mt-4"
                    ref={dropdownRef}
                  >
                    {show && (
                      <div
                        className="dropdown-menu dropdown-menu-end p-0 show"
                        data-bs-popper="none"
                      >
                        <div className="widget-timeline dz-scroll style-1 ps">
                          <ul className="timeline">
                            <li className="mb-0">
                              <div className="timeline-badge primary d-none"></div>
                              <Link
                                to="/Employee/Add"
                                className="timeline-panels text-muted d-inline-flex profiledrop"
                              >
                                <ul className="profiledropul">
                                  <li>
                                    <img src="/images/new-post.png" />
                                  </li>
                                </ul>
                                <h6>Single Employee</h6>
                              </Link>
                            </li>

                            <li className="mb-0">
                              <div className="timeline-badge primary d-none"></div>
                              <Link
                                className="timeline-panels text-muted d-inline-flex profiledrop"
                                to="/UploadEmployee"
                              >
                                <ul className="profiledropul">
                                  <li>
                                    <img src="/images/new-post.png" />
                                  </li>
                                </ul>
                                <h6 htmlFor="doc-upload">Upload Excel</h6>
                              </Link>
                            </li>
                          </ul>
                          <div
                            className="ps__rail-x"
                            style={{ left: "0px", bottom: "0px" }}
                          >
                            <div
                              className="ps__thumb-x"
                              tabIndex="0"
                              style={{ left: "0px", width: "0px" }}
                            ></div>
                          </div>
                          <div
                            className="ps__rail-y"
                            style={{ top: "0px", right: "0px" }}
                          >
                            <div
                              className="ps__thumb-y"
                              tabIndex="0"
                              style={{ top: "0px", height: "0px" }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="tickets-summary">
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Total Employees</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.TotalEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">New Joinees</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.NewEmployee}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Last 30 Days</span>
                    </div>
                  </div>
                </div>

                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Average Age</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.AverageAge}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>In Years/Months</span>
                    </div>
                  </div>
                </div>

                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Men / Women</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.MenVsWomen}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>

                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted"> Total Employees</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.TotalActiveEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>All-Time</span>
                    </div>
                  </div>
                </div>

                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg Tenure</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {employeeCount?.AverageEmployeeTenure}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>In Years/Months</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {employeDetailsOfDropdown.length > 0 && (
            <div className="col-xl-12">
              <div className="form-head d-flex flex-wrap align-items-center">
                <div className="me-auto d-flex">
                  <h2
                    className="font-w600 mb-0 mb-auto mt-auto"
                    style={{ color: " #671cce", fontSize: "17px" }}
                  >
                    {selectedEmployee?.FirstName}'s Team -
                  </h2>
                  <div className="assigntodiv ml-3">
                    <Dropdown
                      name="fullName"
                      value={selectedEmployee}
                      onChange={(e) => {
                        setSelectedEmployee(e.value);
                        handleInputChangeEmployee(e);
                      }}
                      options={employeDetailsOfDropdown?.toSpliced(0, 0, {
                        ProfileImage: EmployeesNameData?.ProfileImage,
                        EmpId: EmployeesNameData?.EmpId,
                        FullName: EmployeesNameData?.FullName,
                        FirstName: EmployeesNameData?.FirstName,
                      })}
                      itemTemplate={employeeOptionTemplate}
                      valueTemplate={selectedAssignName}
                      filter
                      optionLabel="FullName"
                      placeholder="Employee"
                    />
                  </div>
                </div>
                <div className="rightsideteam-tabs">
                  <input
                    type="text"
                    className="form-control"
                    onChange={handleInputChangeForTeam}
                    placeholder="Search here..."
                  />
                </div>
              </div>
            </div>
          )}

          {teamSearchValue ? (
            employeTeamData.length > 0 ? (
              <div className="tile-grid tile-grid-v1 team-listing">
                <div className="col-xl-12">
                  <div className=" row g-2 columns is-multiline all-teammember">
                    {displayedTeams?.map((team, index) => (
                      <div className="column col-md-3" key={index}>
                        <div className="tile-grid-item">
                          <div className="tile-grid-item-inner">
                            <div
                              className="h-avatar is-medium"
                              onClick={() => goToUserDetail(team)}
                              style={{ cursor: "pointer" }}
                            >
                              <LazyImage
                                className="avatar"
                                src={team?.ProfileImage}
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            <div
                              className="meta"
                              onClick={() => goToUserDetail(team)}
                              style={{ cursor: "pointer" }}
                            >
                              <span
                                className="dark-inverted"
                                title={team?.FullName}
                              >
                                {team?.FirstName}
                                {team?.CurrentDesignation && (
                                  <b style={{ fontSize: "0.7rem" }}>
                                    ({team?.CurrentDesignation})
                                  </b>
                                )}
                              </span>
                              <span>
                                <img src="/images/policy/date.svg" />
                                <b>Since </b>:
                                {moment(team.DateOfJoining).format(
                                  "MMM DD YYYY",
                                )}
                              </span>
                              <span>{team?.CurrentDepartment}</span>
                            </div>

                            <div className="meta metadiv2s">
                              <span className="dark-inverted">
                                {team?.EmploymentId}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {employeTeamData.length > 8 && showmember && (
                      <div className="mt-3" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => setShowAll(!showAll)}
                          style={{ color: "white" }}
                        >
                          {showAll ? "Show Less" : "View All"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )
          ) : (
            employeTeamData.length > 0 && (
              <div className="tile-grid tile-grid-v1 team-listing">
                <div className="col-xl-12">
                  <div className=" row g-2 columns is-multiline all-teammember">
                    {displayedTeams?.map((team, index) => (
                      <div className="column col-md-3" key={index}>
                        <div className="tile-grid-item">
                          <div className="tile-grid-item-inner">
                            <div
                              className="h-avatar is-medium"
                              onClick={() => goToUserDetail(team)}
                              style={{ cursor: "pointer" }}
                            >
                              <LazyImage
                                className="avatar"
                                src={team?.ProfileImage}
                                data-demo-src="images/avatar/1.jpg"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                            </div>
                            <div
                              className="meta"
                              onClick={() => goToUserDetail(team)}
                              style={{ cursor: "pointer" }}
                            >
                              <span
                                className="dark-inverted"
                                title={team?.FullName}
                              >
                                {team?.FirstName}
                                {team?.CurrentDesignation && (
                                  <b style={{ fontSize: "0.7rem" }}>
                                    ({team?.CurrentDesignation})
                                  </b>
                                )}
                              </span>
                              <span>
                                <img src="/images/policy/date.svg" />
                                <b>Since </b>:
                                {moment(team.DateOfJoining).format(
                                  "MMM DD YYYY",
                                )}
                              </span>
                              <span>{team?.CurrentDepartment}</span>
                            </div>

                            <div className="meta metadiv2s">
                              <span className="dark-inverted">
                                {team?.EmploymentId}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {employeTeamData.length > 8 && showmember && (
                      <div className="mt-3" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => setShowAll(!showAll)}
                          style={{ color: "white" }}
                        >
                          {showAll ? "Show Less" : "View All"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          )}
          <div>
            {employeDetailsOfDropdown.length > 0 && showmember && (
              <div className="card">
                <div className="Team-notfound">
                  <img src="/images/no-data-found/No_Policy.png" />
                  <p style={{ textTransform: "capitalize" }}>
                    {showNoData} {selectedEmployee?.FullName}
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto mb-3">
                    <strong className="ticket-title m-0" title="All Employees">
                      All Employees ({totalRecords})
                    </strong>
                  </div>
                  {selectedEmployees.length > 0 && (
                    <div
                      className="me-2 select-futurepost-article"
                      title="Bulk Update"
                      onClick={() => {
                        editEmployeeProfile(selectedEmployees);
                      }}
                    >
                      <label style={{ cursor: "pointer" }}>Bulk Update</label>
                      <span className="editprofile-admin">
                        <LazyImage
                          src="/images/org-img/edit.png"
                          className="w-100"
                        />
                      </span>
                    </div>
                  )}
                  {selectedEmployees.length > 0 && (
                    <div
                      className="select-futurepost-article"
                      onClick={() => setVisibleMail(true)}
                      title="Welcome Mail"
                    >
                      <label style={{ cursor: "pointer" }}>
                        Send Welcome Email
                      </label>
                      <div className="editprofile-admin">
                        <img
                          // onClick={() => editEmail(rowData)}
                          src="/images/org-img/editEmail.png"
                          data-bs-toggle="modal"
                        />
                      </div>
                    </div>
                  )}
                  {employeeViewExEmp && (
                    <div
                      className="me-2 select-futurepost-article"
                      title="Ex-Employee View"
                    >
                      <label style={{ cursor: "pointer" }}>Ex-Employee</label>
                      <div className="ml-auto d-flex">
                        <InputSwitch
                          checked={IsExEmployeeView}
                          onChange={(e) => handleInputChangeExEmployee(e)}
                        />
                      </div>
                    </div>
                  )}

                  <Dropdown
                    value={selectedZone}
                    onFocus={(e) => e.target.click()}
                    onChange={(e) => {
                      onChangeZone(e);
                      setSelectedZone(e.value);
                    }}
                    options={ZoneList}
                    optionLabel="Name"
                    showClear
                    optionValue="Id"
                    placeholder="Zone"
                    className="me-2 select-futurepost-article"
                  />
                  <Dropdown
                    value={selectedRegion}
                    onFocus={(e) => e.target.click()}
                    onChange={(e) => {
                      setSelectedRegion(e.value);
                      setCurrentPage(0);
                    }}
                    options={RegionList}
                    optionLabel="Name"
                    optionValue="Id"
                    showClear
                    placeholder="Region"
                    className="me-2 select-futurepost-article"
                  />

                  <div className="actionbutton-tickets">
                    <input
                      type="text"
                      className="form-control"
                      onChange={handleInputChange}
                      placeholder="Search"
                    />
                    {/* <button
                      className="add-teammember"
                      id="filterbtnn"
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      <i aria-hidden="true" className="fa fa-filter"></i>
                    </button> */}
                  </div>
                  {/* {displayedTeams?.length == 0 && <Link to="/Employee/Add">
                    <button className="add-newticket w-auto float-right">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-plus"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                      </svg>
                      New Member
                    </button>
                  </Link>} */}
                  {/* </div> */}
                </div>
                {showFilter && (
                  <div className="filter-div">
                    <div className="card">
                      <div
                        className="card-body d-flex"
                        style={{ flexWrap: "wrap" }}
                      >
                        <div className="col-2 p-2">
                          <label
                            className="col-form-label"
                            htmlFor="validationCustom05"
                            style={{ color: "black" }}
                          >
                            Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name=""
                            className="form-control"
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-2 p-2">
                          <label
                            className="col-form-label"
                            htmlFor="validationCustom05"
                            style={{ color: "black" }}
                          >
                            Email
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name=""
                            className="form-control"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div
                    className={
                      employeeCreate
                        ? "table table-bordered dataTable no-footer teamtablelist employeeviewonly"
                        : "table table-bordered dataTable no-footer teamtablelist "
                    }
                  >
                    <DataTable
                      value={employeeTeam}
                      sortField={sortField}
                      sortOrder={sortOrder}
                      onSort={onSortChange}
                      paginator
                      rows={rowsPerPage}
                      first={currentPage * rowsPerPage}
                      totalRecords={totalRecords}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      rowsPerPageOptions={[25, 50, 100, 200, 500]}
                      lazy={true}
                      onPage={onPageChange}
                      dataKey="EmpId"
                      tableStyle={{ minWidth: "50rem", fontSize: "12px" }}
                      selection={selectedEmployees}
                      onSelectionChange={onSelectionChange}
                      selectAll={selectAll}
                      onSelectAllChange={onSelectAllChange}
                      metaKeySelection={false} // ✅ Prevent row click select
                      selectionMode={undefined} // ✅ Ensure only checkbox triggers selection
                      selectOnEdit={false} // ✅ Just to be safe
                      onRowClick={(e) => e.preventDefault()} // ✅ Prevent row click select
                      dataTableSelectable={false}
                      rowClassName={() => "row-class-team"}
                      emptyMessage={
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "1400px",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "2rem 0",
                          }}
                        >
                          <img
                            src="/images/no-data-found/no ticket.png"
                            alt="No Tickets"
                            style={{ width: "120px" }}
                          />
                          <span style={{ fontSize: "1rem", color: "#6c757d" }}>
                            {noData}
                          </span>
                        </div>
                      }
                      className="ticket-datatable"
                    >
                      {employeeCreate && <Column selectionMode="multiple" />}
                      <Column
                        field="FullName"
                        body={styleFullName}
                        header="Name"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentDesignation"
                        header="Designation"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentDepartment"
                        header="Department"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentBusinessUnit" // messing this will not getting null for now
                        header="Business Unit"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentBand"
                        header="Band"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentGrade"
                        header="Grade"
                      // sortable
                      ></Column>
                      <Column
                        field="CurrentWorkLocation"
                        header="Location"
                      // sortable
                      ></Column>
                      <Column
                        field="AssociatedSince" // messing this will getting null for now
                        header="Associated Since"
                        body={(rowData) =>
                          rowData.DateOfJoining
                            ? moment(rowData.DateOfJoining).format(
                              "MMM DD YYYY",
                            )
                            : "N/A"
                        }
                      // sortable
                      ></Column>
                      <Column
                        field="PhoneNumber"
                        header="Phone"
                      // sortable
                      ></Column>
                      <Column field="UserName" header="Email"></Column>
                      <Column
                        field="OverseerName"
                        header="Reporting Manager"
                        body={styleOverseerName}
                      // sortable
                      ></Column>
                      {employeeCreate && (
                        <Column
                          field="ActualDateOfBirth"
                          header="DOB"
                          body={(rowData) =>
                            rowData.ActualDateOfBirth
                              ? moment(rowData.ActualDateOfBirth).format(
                                "MMM DD YYYY",
                              )
                              : "-"
                          }
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="CurrentWorkMode"
                          header="Work Mode"
                        // sortable
                        ></Column>
                      )}
                      <Column
                        field="CurrentWorkShift"
                        header="Work Shift"
                      // sortable
                      ></Column>
                      {employeeCreate && (
                        <Column
                          field="EmployeeType"
                          header="Employee Type"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="EmploymentStatus"
                          header="Employment Status"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="BankAccountNumber"
                          header="Bank Account Number"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="BankIFSCRoutingNumber"
                          header="Bank IFSC Routing Number"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="BankName"
                          header="Bank Name"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="UANNumber"
                          header="UAN Number"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="NationalId"
                          header="National Id"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="PanNumber"
                          header="Pan Number"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="ESIApplicable"
                          header="ESI Applicable"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="DirectReporteeCount"
                          header="Reportee Count"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="FatherName"
                          header="Father Name"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="MotherName"
                          header="Mother Name"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="SpouseName"
                          header="Spouse Name"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="DateOfMarriage"
                          header="Date Of Marriage"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="Experience"
                          header="Experience"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="LastSalarychange"
                          header="Last Salary change"
                        // sortable
                        ></Column>
                      )}
                      {employeeCreate && (
                        <Column
                          field="LastDesignationChangeOn"
                          header="Last Designation Change On"
                        // sortable
                        ></Column>
                      )}
                      <Column
                        header="Action"
                        body={actionBodyTemplate}
                        style={{ width: "93px" }}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade custom-modal-area"
              id="edit-Email"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content add-editbadge add-editexperience">
                  <div className="modal-header">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="backimg"
                    />
                    <div className="img">
                      <img src="/images/popup-icons/featured-post.png" />
                    </div>
                    <button
                      onClick={handleCloseModal}
                      type="button"
                      className="btn-close m-auto"
                      id="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div className="modal-body ">
                    <h5 className="modal-title text-center">{emailHeader}</h5>
                    <p className="text-center">{emailText}</p>
                    <div className="addcourseform">
                      <form onSubmit={emailFrom.handleSubmit}>
                        <div className="row">
                          <div className="mb-4 col-md-12 mt-3">
                            <label className="form-label">
                              Email Id
                              <i className="inValidError">*</i>
                            </label>
                            <div className="">
                              <input
                                type="text"
                                cols="1"
                                rows="4"
                                name="email"
                                className={
                                  "form-control" +
                                  (emailFrom.errors.email &&
                                    emailFrom.touched.email
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={(e) => {
                                  emailFrom.setFieldValue(
                                    "email",
                                    e.target.value.trimStart(),
                                  );
                                  setEmailValid("");
                                }}
                                value={emailFrom.values.email}
                                placeholder="Enter Your Email"
                              />
                            </div>
                            <div className="invalid-feedback">
                              {emailFrom.errors.email && emailFrom.touched.email
                                ? emailFrom.errors.email
                                : null}
                            </div>
                            {emailValid && (
                              <div className="invalid-feedback">
                                {emailValid}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="modal-footer m-auto justify-content-center">
                          <button
                            type="button"
                            className="cancelbtn-click"
                            data-bs-dismiss="modal"
                            onClick={handleCloseModal}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="savebtn-click"
                            disabled={Isloading}
                          >
                            {Isloading ? "Update..." : "Update"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-content-center">
              <Dialog visible={visible}>
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content add-editbadge custom-modal-area">
                    <div className="modal-body text-center">
                      <div className="modal-header">
                        <img
                          src="/images/org-img/leave/popup-backimg.png"
                          className="backimg"
                        />
                        <div className="img">
                          <img src="/images/popup-icons/featured-post.png" />
                        </div>
                      </div>
                      <strong className="modal-title">
                        <h5 className="modal-title m-auto">
                          Your Updated Official Email
                        </h5>
                      </strong>

                      {/* <p>{employee[0]?.UserName}</p> */}
                      <div className="addcourseform">
                        <div className="row">
                          <div className="mb-4 col-md-12 mt-3">
                            <label className="form-label">
                              Please log out and log in again to apply the
                              changes.
                            </label>
                          </div>
                        </div>
                        <div className="modal-footer m-auto justify-content-center">
                          <button
                            type="submit"
                            className="savebtn-click"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog>
            </div>
            <div className="flex justify-content-center">
              <Dialog
                visible={visibleEmpUpdate}
                onHide={() => {
                  if (!visibleEmpUpdate) return;
                  setVisibleEmpUpdate(false);
                }}
                closable={false}
                className="overflow-visible"
              >
                <div className="custom-modal-area ">
                  <div className="modal-content add-editbadge">
                    <div className="modal-header">
                      <img
                        src="/images/org-img/leave/popup-backimg.png"
                        className="backimg"
                      />
                      <div className="img">
                        <img src="/images/popup-icons/featured-post.png" />
                      </div>
                    </div>
                    <div className="modal-body ">
                      <h5 className="modal-title text-center">
                        Select field that you want to update
                      </h5>
                      {/* <p></p> */}
                      <div className="addcourseform mt-3">
                        <form onSubmit={updateEmployeeRecordFrom.handleSubmit}>
                          <div className="row">
                            <div className="cover-form">
                              <Dropdown
                                name="selectedField"
                                value={updateField}
                                onChange={(e) => {
                                  const selected = e.value;
                                  updateEmployeeRecordFrom.setFieldValue(
                                    "selectedField",
                                    selected,
                                  );
                                  updatefieldValue(selected);

                                  if (selected?.KeyName) {
                                    updateEmployeeRecordFrom.setFieldValue(
                                      selected.KeyName,
                                      "",
                                    );
                                  }
                                }}
                                options={employeeKeyDeta}
                                optionLabel="KeyDesc"
                                // DO NOT SET optionValue → default is full object
                                placeholder="Select for update"
                                filter
                              />
                            </div>
                            {/* Validation error for selectedField */}
                            <div className="invalid-feedback d-block">
                              {updateEmployeeRecordFrom.touched.selectedField &&
                                updateEmployeeRecordFrom.errors.selectedField}
                            </div>

                            {updateField && (
                              <div className="mb-4 col-md-12 mt-3">
                                {updateField?.KeyId && (
                                  <div className="mb-4 col-md-12 mt-3">
                                    <label className="form-label">
                                      {updateField?.KeyDesc}
                                      <i className="inValidError">*</i>
                                    </label>

                                    {renderFormField(
                                      updateField,
                                      updateEmployeeRecordFrom,
                                    )}

                                    {/* Validation error */}
                                    <div className="invalid-feedback d-block">
                                      {updateEmployeeRecordFrom.touched[
                                        updateField.KeyName
                                      ] &&
                                        updateEmployeeRecordFrom.errors[
                                        updateField.KeyName
                                        ]}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="modal-footer justify-content-center">
                            <button
                              type="button"
                              className="cancelbtn-click"
                              data-bs-dismiss="modal"
                              onClick={() => {
                                setVisibleEmpUpdate(false);
                                updateCancel();
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-purple rounded"
                            >
                              Update ({selectedEmployees.length}) Employee
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog>
              <Dialog visible={visibleMail} closable={false}>
                <div className="custom-modal-area logout-user">
                  <div className="modal-content add-editbadge add-editexperience">
                    <div className="modal-header">
                      <img
                        src="/images/org-img/leave/popup-backimg.png"
                        className="backimg"
                      />
                      <div className="img">
                        <img src="/images/popup-icons/featured-post.png" />
                      </div>
                    </div>
                    <div className="modal-body text-center">
                      <h5 className="modal-title ">
                        Confirm sending welcome emails to (
                        {selectedEmployees.length}) Employee
                      </h5>

                      <div className="addcourseform ">
                        {/* <div className="row">
                              <div className="mb-4 col-md-12 mt-3">
                                <label className="form-label">
                                  Please log out and log in again to apply the changes.
                                </label>
                              </div>
                            </div> */}
                        <div className="modal-footer m-auto justify-content-center mt-4">
                          <button
                            type="button"
                            className="cancelbtn-click"
                            data-bs-dismiss="modal"
                            onClick={() => setVisibleMail(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="savebtn-click"
                            onClick={() => sendMail()}
                          >
                            Send Email
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog>
            </div>
          </div>
        </div>

        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : showLoader ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default TeamDirectory;
